import styled from "styled-components";
import BasePlanPrice from "../components/PlanPrice";
import { PlanProducts as BasePlanProducts } from "./PlanCard";

export const Card = styled.div`
  box-shadow: ${({ theme }) => theme.shadows.sticky};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 30px 20px 16px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[500]};
`;

export const CardTitle = styled.h2`
  text-align: center;
`;

export const PlanProducts = styled(BasePlanProducts)`
  margin: 0 auto;
  padding-bottom: 14px;
`;

export const PlanPrice = styled(BasePlanPrice)`
  justify-content: center;
`;

export const Loading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 141px;

  svg {
    width: 18px;
    height: 18px;
    margin-right: 5px;
  }
`;
